<template>
  <div class="openings">
    <table>
      <tr v-for="day in openings" :class="{}" :key="day.date">
        <template v-if="day === 'separator'" class="text-center">
          <td :colspan="openings.colCount + 1" class="separator"></td>
        </template>
        <template v-else>
          <td>
            {{ day.label }}
            <div v-if="day.holiday" class="holiday-label">{{ day.displayDate }} - {{day.holiday}}</div>
          </td>
          <td v-if="Array.isArray(day.open)" v-for="(hour, hourindex) in day.open" :key="day.date + '-' + hourindex">

            <div v-if="hour.length === 2" :class="{'line-through': day.holiday || day.hasOwnProperty('override')}">{{ hour[0] }} - {{ hour[1] }}</div>
            <div v-if="day.holiday && holidayOpen[hourindex] && holidayOpen[hourindex].length === 2 && !day.hasOwnProperty('override')" class="holiday-hour">
              {{holidayOpen[hourindex][0] }} - {{ holidayOpen[hourindex][1] }}
            </div>
            <div v-if="day.holiday && (!holidayOpen[hourindex] || holidayOpen[hourindex].length != 2) && !day.hasOwnProperty('override')">&nbsp;</div>
            <div v-if="day.hasOwnProperty('override') && !day.override">Geschlossen</div>
          </td>
          <td v-if="!Array.isArray(day.open)" :colspan="openings.colCount" class="text-center">
            {{day.open ? day.open : 'Geschlossen'}}
          </td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
moment.locale('de')

export default {
  name: 'OpeningHours',
  data: function () {
    return {
      today: moment().format('YYYY-MM-DD'),
      holidays: null,
      openings: null,
      holidayOpen: [[], ['17:30', '22:00']],
    }
  },
  asyncComputed: {
    ...mapState(['location']),
    openings() {
    this.$moment.locale('DE')
    // fetch('https://feiertage-api.de/api/?jahr=' + (new Date()).getFullYear() + '&nur_land=' + 'BW')
    //   .then(response => response.json())
    //   .then((holidayIn) => {
    var holidayIn = []
    var holidays = {}
    for (var holidayName in holidayIn) {
      if (!holidayIn.hasOwnProperty(holidayName)) continue
      var date = holidayIn[holidayName].datum
      if (holidays[date]) {
        holidays[date] += ' | ' + holidayName
      } else {
        holidays[date] = holidayName
      }
    }
    this.holidays = holidays

    // var mom = moment()
    var mom = moment()
    var openings = []
    if (this.location) {
    for (var i = 0; i < 7; ++i) {
      var day = {
        displayDate: mom.format('D.M.'),
        label: mom.locale('de').format('dddd'),
        date: mom.format('YYYY-MM-DD'),
        weekdayIndex: mom.locale('en').format('dddd').toLowerCase().substring(0, 3),
      }
      day.open = this.location.openings[day.weekdayIndex]
      if (this.holidays && this.holidays[day.date]) {
        day.holiday = this.holidays[day.date]
      }
      openings.push(day)
      mom.add(1, 'days')
    }

    openings.push('separator')
    openings.push({
      label: 'Feiertags',
      open: this.location.openings.hol,
    })
    }
    var colCount = 0
    openings.forEach(function (day) {
      if (!day.open) return
      if (day.open.length > colCount) {
        colCount = day.open.length
      }
    })
    openings.colCount = colCount
    return openings
    },
  },

}
</script>

<style lang="scss" scoped>

table {
  width: 100%;
  tr {
    &:not(:last-child) {
      border-bottom: 1px solid rgba(255,255,255,.1)
    }
    &:first-child {
      font-weight: bold;
    }
  }
  td {
    white-space: nowrap;
    text-align: center;
    padding: .1em .5em;
    &:not(:last-child):first-child {
      text-align: left;
      padding-left: 0;
    }
    &:not(:first-child):last-child {
      text-align: right;
      padding-right: 0;
    }
  }
}

.openings {
  width: 100%;
  display:table;

  .seperator {
    display:table-row;
    > * {
      border-bottom: 1px dashed rgba(255,255,255,.2);
      height: 1px;
      padding-top: .3em;
    }
  }
}

.openings-day {
  display:table-row;
}
.today {
  font-weight: bold;
}
.line-through {
  text-decoration: line-through;
}
.invisible {
  opacity: 0;
}

.openings-day-name, .openings-day-hours {
  display:table-cell;
}

.openings-day-hours {
  text-align: center;
  vertical-align: center;
}
.holiday-label, .holiday-hour {
  font-style: italic;
}

</style>
